module.exports = __webpack_public_path__ + "static/404.bfe5988e.gif";